import { Icon } from '@chakra-ui/react';
import {
  MdHome,
  MdPerson,
  MdLock,
  MdDashboard,
  MdPeople,
  MdCalendarMonth,
  MdLocalHospital,
  MdInventory2,
  MdAccountBalance,
} from 'react-icons/md';
import { Navigate } from 'react-router-dom';

// Dashboard views per role
import AdminDashboard from 'pages/admin/adminDashboard';
import FisioDashboard from 'pages/professional/fisioDashboard';
import MedicoDashboard from 'pages/professional/medicoDashboard';

// Shared views
import Profile from 'pages/professional/profile';
import PatientsView from 'pages/professional/patients';
import PatientDetail from 'pages/professional/patients/PatientDetail';
import EpisodeDetailPage from 'pages/professional/patients/EpisodeDetailPage';
import AppointmentsView from 'pages/professional/appointments';
import ClinicaView from 'pages/professional/clinica';
import PagosView from 'pages/professional/pagos';
import ServicesView from 'pages/admin/services';


// Auth views
import SignInCentered from 'pages/auth/signIn';
import AuthCallback from 'pages/auth/callback';
import ForgotPassword from 'pages/auth/forgotPassword';
import { CalendarPreview } from 'pages/preview/CalendarPreview';
import AppointmentSchedulingPreview from 'pages/preview/AppointmentSchedulingPreview';
import { VerificationCodeInputPreview } from 'pages/preview/VerificationCodeInputPreview';
import EpisodeCardPreview from 'pages/preview/EpisodeCardPreview';
import TreatmentPlansPreview from 'pages/preview/TreatmentPlansPreview';

const routes: RoutesType[] = [
  // ── Dashboard (por rol) ───────────────────────────────────
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdDashboard} width='20px' height='20px' color='inherit' />,
    component: <AdminDashboard />,
    roles: ['admin'],
  },
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/fisio',
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: <FisioDashboard />,
    roles: ['fisioterapeuta', 'pasante'],
  },
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/medico',
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: <MedicoDashboard />,
    roles: ['medico'],
  },

  // ── Pacientes ────────────────────────────────────────────
  {
    name: 'Pacientes',
    layout: '/admin',
    path: '/patients',
    icon: <Icon as={MdPeople} width='20px' height='20px' color='inherit' />,
    component: <PatientsView />,
    roles: ['admin', 'fisioterapeuta', 'medico', 'pasante'],
  },
  {
    name: 'Detalle Paciente',
    layout: '/admin',
    path: '/patients/:id',
    icon: '',
    component: <PatientDetail />,
    roles: ['admin', 'fisioterapeuta', 'medico', 'pasante'],
    hidden: true,
  },
  {
    name: 'Episodio Clínico',
    layout: '/admin',
    path: '/patients/:id/episodes/:episodeId',
    icon: '',
    component: <EpisodeDetailPage />,
    roles: ['admin', 'fisioterapeuta', 'medico', 'pasante'],
    hidden: true,
  },

  // ── Agenda ───────────────────────────────────────────────
  {
    name: 'Agenda',
    layout: '/admin',
    path: '/agenda',
    icon: <Icon as={MdCalendarMonth} width='20px' height='20px' color='inherit' />,
    component: <AppointmentsView />,
    roles: ['admin', 'fisioterapeuta', 'medico', 'pasante'],
  },

  // ── Operaciones Clínicas ──────────────────────────────────
  {
    name: 'Operaciones Clínicas',
    layout: '/admin',
    path: '/clinica',
    icon: <Icon as={MdLocalHospital} width='20px' height='20px' color='inherit' />,
    component: <ClinicaView />,
    roles: ['admin', 'fisioterapeuta', 'medico', 'pasante'],
  },

  // ── Pagos y Facturación ──────────────────────────────────
  {
    name: 'Pagos y Facturación',
    layout: '/admin',
    path: '/pagos',
    icon: <Icon as={MdAccountBalance} width='20px' height='20px' color='inherit' />,
    component: <PagosView />,
    roles: ['admin', 'fisioterapeuta', 'medico', 'pasante'],
  },

  // ── Servicios e Inventario ───────────────────────────────
  {
    name: 'Servicios e Inventario',
    layout: '/admin',
    path: '/services',
    icon: <Icon as={MdInventory2} width='20px' height='20px' color='inherit' />,
    component: <ServicesView />,
    roles: ['admin', 'fisioterapeuta', 'medico'],
  },

  // ── Perfil (oculto del sidebar, ruta activa) ─────────────
  {
    name: 'Perfil',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: <Profile />,
    roles: ['admin', 'fisioterapeuta', 'medico', 'pasante', 'paciente'],
    hidden: true,
  },

  // ── Auth ─────────────────────────────────────────────────
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: <SignInCentered />,
  },
  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: <Navigate to='/auth/sign-in' replace />,
  },
  {
    name: 'Auth Callback',
    layout: '/auth',
    path: '/callback',
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: <AuthCallback />,
  },
  {
    name: 'Forgot Password',
    layout: '/auth',
    path: '/forgot-password',
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: <ForgotPassword />,
  },
  {
    name: 'Calendar Preview Test',
    layout: "/preview",
    path: "/preview/calendar",
    icon: <Icon as={MdCalendarMonth} width='20px' height='20px' color='inherit' />,
    component: <CalendarPreview />,
  },
  {
    name: 'Agendamiento de citas Preview',
    layout: '/preview',
    path: '/preview/appointment-scheduling',
    icon: <Icon as={MdCalendarMonth} width='20px' height='20px' color='inherit' />,
    component: <AppointmentSchedulingPreview />,
  },
  {
    name: 'Verification Code Preview',
    layout: '/preview',
    path: '/preview/verification-code',
    icon: '',
    component: <VerificationCodeInputPreview />,
  },
  {
    name: 'Episode Card Preview',
    layout: '/preview',
    path: '/preview/episode-card',
    icon: '',
    component: <EpisodeCardPreview />,
  
  },
];

export default routes;
